import { render, staticRenderFns } from "./tax_incentives_result.vue?vue&type=template&id=b76a03ec&scoped=true&"
import script from "./tax_incentives_result.vue?vue&type=script&lang=js&"
export * from "./tax_incentives_result.vue?vue&type=script&lang=js&"
import style0 from "./tax_incentives_result.vue?vue&type=style&index=0&id=b76a03ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76a03ec",
  null
  
)

export default component.exports